var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#313131"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16666 2.71716L6.17958 18.5332C6.17958 18.8149 6.10203 19.2887 6.46394 19.0326C6.58027 18.9558 6.87756 18.61 6.99389 18.4947C7.18777 18.3026 7.32995 18.149 7.5109 17.9569C7.73064 17.7648 7.87282 17.6623 8.05377 17.4574L9.56605 15.8822C10.3674 15.0754 10.2511 15.4084 11.1042 17.3678L12.8491 21.4018C13.2369 22.3367 13.4437 22.0165 14.6587 21.5171C15.8478 21.0176 16.1839 21.0432 15.822 20.2108C15.5376 19.5321 15.2533 18.8533 14.956 18.1874C14.6716 17.5086 14.3872 16.8555 14.09 16.1768C13.1593 13.9356 12.9396 13.9869 14.1546 13.9869C14.8526 13.9869 18.3037 14.0893 18.6526 13.8972C18.8207 13.7051 17.4247 12.5397 17.2567 12.386C16.688 11.861 16.4424 11.5408 15.6927 10.8749C14.4777 9.78633 13.043 8.26236 11.8022 7.13539C11.5178 6.87926 11.2981 6.67436 11.0137 6.40543L6.99999 2.83333C6.16666 2 6.16666 2 6.16666 2V2.71716Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer);
export default __webpack_public_path__ + "static/media/Pointer.ae4dfe59a2880d887bbf36d02b07db57.svg";
export { ForwardRef as ReactComponent };